module.exports = __webpack_public_path__ + "media/images/comment_customer-8d3c4196.png";